import { iamApiSlice } from './iamApiSlice';

export interface Organization {
  id: string;
  name: string;
  code: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  version: number;
}

export type OrgResponse = Organization[];

export const orgApi = iamApiSlice.injectEndpoints({
  endpoints: builder => ({
    getOrgs: builder.query<OrgResponse, void>({
      query: () => '/orgs/my',
      providesTags: ['Organization'],
    }),
    getAllOrgs: builder.query<OrgResponse, void>({
      query: () => '/orgs/all',
      providesTags: ['Organization'],
    }),
    createOrg: builder.mutation<Organization, { name: string }>({
      query: body => ({
        url: '/orgs',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Organization'],
    }),
    verifyInvitation: builder.query<
      { orgName: string; email: string; status: string; userExists: boolean },
      string
    >({
      query: token => `/orgs/invitations/verify?token=${token}`,
    }),
    acceptInvitation: builder.mutation<void, string>({
      query: token => ({
        url: `/orgs/invitations/accept?token=${token}`,
        method: 'POST',
      }),
      invalidatesTags: ['Organization'],
    }),
    rejectInvitation: builder.mutation<void, string>({
      query: token => ({
        url: `/orgs/invitations/reject?token=${token}`,
        method: 'POST',
      }),
    }),
    inviteUser: builder.mutation<void, { orgId: string; email: string }>({
      query: ({ orgId, email }) => ({
        url: `/orgs/${orgId}/invite`,
        method: 'POST',
        body: { email },
      }),
    }),
  }),
});

export const {
  useGetOrgsQuery,
  useGetAllOrgsQuery,
  useCreateOrgMutation,
  useVerifyInvitationQuery,
  useAcceptInvitationMutation,
  useRejectInvitationMutation,
  useInviteUserMutation,
} = orgApi;
